import {createSelector} from '@reduxjs/toolkit'

const selectCouponState = state => state.ccCouponState

export const selectManualCoupons = createSelector(
  selectCouponState,
  coupon => coupon.manualCoupons,
)

export const selectAutoCoupons = createSelector(
  selectCouponState,
  coupon => coupon.autoCoupons,
)

export const selectDefaultCoupons = createSelector(
  selectCouponState,
  coupon => coupon.defaultCoupons,
)

export const selectMergedCoupons = createSelector(
  selectCouponState,
  coupon => coupon.mergedCoupons,
)

export const selectIncentiveCoupon = createSelector(
  selectCouponState,
  coupon => coupon.incentiveCoupon,
)

export const selectUpgradeCoupons = createSelector(
  selectCouponState,
  coupon => coupon.upgradeCoupons,
)

export const selectUpgradePaymentPreview = createSelector(
  selectCouponState,
  coupon => coupon.upgradePaymentPreview,
)

export const selectAppliedCouponsFlag = createSelector(
  selectCouponState,
  coupon => coupon.appliedCoupons,
)
